/**
 * Per-tab "parent zone" unlock flag. Cleared on tab close & on logout.
 * Used so the PIN is only asked once per browser session — when the
 * parent first switches into the parent profile / settings / quest grading.
 */
const KEY = "sgcf:parent_unlocked";

export const isParentUnlocked = () => {
    try {
        return sessionStorage.getItem(KEY) === "1";
    } catch {
        return false;
    }
};

export const setParentUnlocked = (v) => {
    try {
        if (v) sessionStorage.setItem(KEY, "1");
        else sessionStorage.removeItem(KEY);
    } catch {}
};
